/**
 * Heritage Dahlias, ScrollToTop
 *
 * Reset the window scroll position to the top of the page whenever the React
 * Router location changes. This includes public pages, Heritage HQ, the Admin
 * portal, and every internal navigation.
 *
 * Mount once near the top of <BrowserRouter>.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    // If a hash anchor is present, defer to native browser behaviour so
    // anchor-link navigation still lands on the right section.
    if (hash) return;
    // Use 'auto' (not smooth) so the transition is instantaneous and not
    // distracting when moving between pages.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search, hash]);
  return null;
}
